/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VmcHostUsage { 
    sku?: string;
    region?: string;
    instance_type?: string;
    subscription_count?: number;
    host_usage_count?: number;
    overage?: number;
}

